import { tns } from 'tiny-slider/src/tiny-slider'


export default () => {

	const els = [...document.querySelectorAll('.which-areas__content')]
	els.map(el => {

		const carouselEl = el.querySelector('.which-areas__area__cont')
		if (!carouselEl) return null

		const navigation = el.querySelector('.carousel-settings__navigation')
		const controls = el.querySelector('.carousel-settings__controls')

		return tns({
			container: carouselEl,
			items: 1.5,
			nav: true,
			navPosition: 'bottom',
			navAsThumbnails: true,
			navContainer: navigation,
			controls: true,
			controlsContainer: controls,
			touch: true,
			mouseDrag: true,
			loop: true,
            autoplay: false,
            autoplayButton: false,
            animateDelay: 1000,
			slideBy: 1,
			responsive : {
				750 : { 
					items : 2,
					// controls: false,
				},
				1150 : { disable: true, },
			}
		})
	})
}
